import type {
  Preference,
  PreferenceFileResponse,
  UpdatePreferenceRequest,
} from '@/domains/system-management/types/preference';
import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import { request } from '@/shared/utils/request';

export const preferenceApi = {
  // Get preference
  getPreference: async (): Promise<ApiResponse<Preference[]>> => {
    const url = `${URLS.BACK_DSH}${APIS.preference}`;
    return request.get(url);
  },

  // Update preference
  updatePreference: async (data: UpdatePreferenceRequest): Promise<ApiResponse<null>> => {
    const url = `${URLS.BACK_DSH}${APIS.preference}`;
    return request.put(url, data);
  },

  uploadPreferenceFile: async (data: FormData): Promise<PreferenceFileResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.preferenceFile}`;
    return request.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
